module.exports = __webpack_public_path__ + "img/52002745_L.3a12e15e.png";